import { Component, OnInit,Output,EventEmitter } from '@angular/core';
import { User } from '../../../models/User';
import { HttpService } from '../../../services/HttpService';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  ForgotEmail: string;
  ErrorMessage: string;
  HideForgotPasswordForm; boolean;
  @Output() CloseEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() ActionEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  
  constructor(private http: HttpService) { }

  ngOnInit(): void {
    debugger;
    this.ForgotEmail = "";
    this.HideForgotPasswordForm = false;
  }

  SendForgotPassword(): void {
    if (this.ForgotEmail && this.ForgotEmail != "") {
      var forgotUser = new User();
      forgotUser.Email = this.ForgotEmail;
      this.http.ForgotPassword(forgotUser).then(wrap => {
        if (wrap.StatusCode == "200") {
          this.ForgotEmail = "";
          this.HideForgotPasswordForm = true;
          this.ActionEventEmitter.emit("success");
        }
        else {
          this.ErrorMessage = wrap.Message;
        }
      });
    }

  }

  CancelForgotPassword(): void {
    this.CloseEventEmitter.emit("");
  }
}
